<template>
  <v-alert
    v-if="!subscriptions || subscriptions.length === 0"
    type="info"
    prominent
    elevation="10"
    border="bottom"
    color-border
    class="ma-4"
  >
    It looks like you haven't set up any subscriptions yet! Go back to
    <a
      target="_parent"
      href="/rtt/public/transit.aspx?page=map"
      class="white--text font-weight-bold"
      >our map</a
    >
    and select a stop to create one
  </v-alert>
  <v-layout pa-12 align-center justify-center v-else-if="initialising">
    <v-progress-circular indeterminate size="64"></v-progress-circular>
  </v-layout>
  <v-layout v-else>
    <v-tabs-items v-model="carouselModel" class="flex xs12" :touchless="true">
      <v-tab-item>
        <v-list two-line light text-left>
          <v-divider></v-divider>
          <template v-for="(sub, subIndex) in subscriptions">
            <v-list-item
              :key="subIndex"
              @click="selectSub(sub)"
              :class="sub.fromCookie ? 'pink lighten-4' : ''"
            >
              <v-list-item-action v-if="$vuetify.breakpoint.smAndUp">
                <v-badge :value="sub.fromCookie" color="warning" left overlap>
                  <template #badge>
                    <v-icon style="color: rgba(0, 0, 0, 0.54)">
                      new_releases
                    </v-icon>
                  </template>
                  <v-avatar color="primary">
                    <v-icon dark>flag</v-icon>
                  </v-avatar>
                </v-badge>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title class="title font-weight-light">{{
                  stopName(sub.platformTag)
                }}</v-list-item-title>
                <span class="d-flex align-center body-2">
                  <v-icon>{{
                    sub.enabled ? "notifications" : "notifications_off"
                  }}</v-icon>
                  Notifications {{ sub.enabled ? "on" : "off" }}
                </span>
                <v-list-item-subtitle>
                  <!--<span v-if="sub.projectTag && sub.warningTime && sub.routeNo && sub.routeName && sub.destination && (sub.notBefore !== '00:00' || sub.notAfter !== '23:59' || sub.tripScheduleTag) && sub.weekdayNames.length  && (sub.validTo && sub.validTo.toString() !== '1900-01-01T00:00:00')">-->
                  <span
                    v-if="
                      sub.projectTag &&
                      sub.warningTime &&
                      sub.routeNo &&
                      sub.routeName &&
                      sub.destination &&
                      (sub.notBefore !== '00:00' ||
                        sub.notAfter !== '23:59' ||
                        sub.tripScheduleTag) &&
                      sub.weekdayNames.length &&
                      (!sub.validTo ||
                        (sub.validTo &&
                          sub.validTo.toString() !== '1900-01-01T00:00:00'))
                    "
                  >
                    {{ getWeekdayDescription(sub.weekdayNames) }} &bull;
                    {{ sub.routeNo || sub.routeName }} &bull;
                    {{ sub.destination }}
                  </span>
                  <span
                    v-else-if="
                      sub.projectTag &&
                      sub.warningTime &&
                      sub.routeNo &&
                      sub.routeName &&
                      sub.destination &&
                      (sub.notBefore !== '00:00' ||
                        sub.notAfter !== '23:59' ||
                        sub.tripScheduleTag) &&
                      sub.weekdayNames.length &&
                      sub.validTo &&
                      sub.validTo.toString() === '1900-01-01T00:00:00'
                    "
                  >
                    {{ getWeekdayDescription(sub.weekdayNames) }} &bull;
                    {{ sub.routeNo || sub.routeName }} &bull;
                    {{ sub.destination }}<br />Subscription expired due to
                    schedule changes.
                  </span>
                  <span v-else-if="!sub.destination">
                    Tap here to set up a notification for this stop
                  </span>
                  <span
                    class="d-flex align-center body-2"
                    v-if="
                      $vuetify.breakpoint.xs &&
                      sub.validTo &&
                      sub.validTo.toString() === '1900-01-01T00:00:00'
                    "
                  >
                    <v-btn
                      x-small
                      color="error"
                      @click="deleteInvalidSubscription(sub)"
                    >
                      Delete
                    </v-btn>
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action class="d-none d-sm-flex">
                <v-icon
                  v-if="
                    (sub.validTo &&
                      sub.validTo.toString() !== '1900-01-01T00:00:00') ||
                    !sub.validTo
                  "
                  large
                  >chevron_right</v-icon
                >
                <v-btn
                  v-else
                  color="error"
                  @click="deleteInvalidSubscription(sub)"
                >
                  <v-icon class="mr-1 ml-n1">delete</v-icon>Delete
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider :key="'divider-' + subIndex"></v-divider>
          </template>
        </v-list>
      </v-tab-item>
      <v-tab-item class="flex xs12">
        <SubscriptionEdit
          :model="subscription"
          v-on="$listeners"
          @done="refresh"
        ></SubscriptionEdit>
      </v-tab-item>
    </v-tabs-items>
  </v-layout>
</template>

<script>
export default {
  components: {
    SubscriptionEdit: () => import("./SubscriptionEdit.vue"),
  },
  //props: {
  //    model: Object
  //},
  data: () => ({
    carouselModel: 0,
    subscription: null,
    mapData: null,
    initialising: true,
    initData: null,
  }),
  computed: {
    user() {
      return this.$store.state.user;
    },
    subscriptions() {
      return this.$store.state.subscriptions;
    },
    projects() {
      return this.initData.Projects.map((x) => {
        return { text: x.Name, value: x.Tag };
      });
    },
  },
  methods: {
    initialise() {
      return this.$store.state.axios
        .get("api/subscriptions/InitData")
        .then((response) => {
          this.initData = response.data;
          this.initialising = false;
        });
    },
    stopName(tag) {
      var name;
      return name || this.initData.Platforms.find((x) => x.Tag == tag).Name;
    },

    deleteInvalidSubscription(sub) {
      var p;
      p = this.$store.state.axios.delete(
        "api/subscription/" +
          this.$store.state.user.cnxUserId +
          "/" +
          sub.subscriptionId
      );
      p.then(() => {
        this.$emit("done");
      }).catch((e) => {
        console.log(e);
        alert("Could not delete your subscription. Please try again.");
      });
    },
    selectSub(sub) {
      if (
        (sub.validTo && sub.validTo.toString() !== "1900-01-01T00:00:00") ||
        !sub.validTo
      ) {
        this.subscription = sub;
        if (this.projects.length === 1)
          this.subscription.projectTag = this.projects[0].value;
        this.carouselModel = 1;
        console.warn(sub);
      }
    },
    refresh() {
      this.carouselModel = 0;
    },
    getWeekdayDescription(week) {
      if (week.length === 1) return week[0] + "s";
      let weekend = '["Saturday","Sunday"]';
      if (JSON.stringify([...week].sort()) == weekend) return "Weekends";
      let weekdays = '["Friday","Monday","Thursday","Tuesday","Wednesday"]';
      if (JSON.stringify([...week].sort()) == weekdays) return "Weekdays";
      return week.map((x) => x.slice(0, 3)).join(", ");
    },
  },
  created() {
    this.initialise();
  },
};
</script>
